import React from 'react';

export const TaskGrey = ({ width = 16, height = 16, className = '' }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0791 7.17525C12.307 7.40305 12.307 7.7724 12.0791 8.00021L7.99581 12.0835C7.76801 12.3113 7.39866 12.3113 7.17085 12.0835C6.94305 11.8557 6.94305 11.4864 7.17085 11.2586L11.2542 7.17525C11.482 6.94744 11.8513 6.94744 12.0791 7.17525Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.26256 2.26696C2.59075 1.93877 3.03587 1.75439 3.5 1.75439H10.5C10.9641 1.75439 11.4092 1.93877 11.7374 2.26696C12.0656 2.59515 12.25 3.04027 12.25 3.50439V7.58773C12.25 7.90989 11.9888 8.17106 11.6667 8.17106H8.16667V11.6711C8.16667 11.9932 7.9055 12.2544 7.58333 12.2544H3.5C3.03587 12.2544 2.59075 12.07 2.26256 11.7418C1.93437 11.4136 1.75 10.9685 1.75 10.5044V3.50439C1.75 3.04027 1.93437 2.59515 2.26256 2.26696ZM3.5 2.92106C3.34529 2.92106 3.19692 2.98252 3.08752 3.09192C2.97812 3.20131 2.91667 3.34968 2.91667 3.50439V10.5044C2.91667 10.6591 2.97812 10.8075 3.08752 10.9169C3.19692 11.0263 3.34529 11.0877 3.5 11.0877H7V8.17106C7 7.86164 7.12292 7.5649 7.34171 7.3461C7.5605 7.12731 7.85725 7.00439 8.16667 7.00439H11.0833V3.50439C11.0833 3.34969 11.0219 3.20131 10.9125 3.09192C10.8031 2.98252 10.6547 2.92106 10.5 2.92106H3.5Z"
      fill="currentColor"
    />
  </svg>
);
